import { z } from "zod";
import { SearchParamsPagination } from "../_core.js";
import { ServiceReport } from "../business_central.js";
export const ListCustomerServiceReportsSearchParams = SearchParamsPagination.meta({
    ref: "ListCustomerServiceReportsSearchParams",
});
export const ListCustomerServiceReportsResponseBody = z
    .object({
    serviceReports: ServiceReport.array(),
})
    .meta({ ref: "ListCustomerServiceReportsResponseBody" });
export const ReadServiceReportPathParams = z
    .object({
    id: z.string(),
})
    .meta({ ref: "ReadServiceReportPathParams" });
export const ReadServiceReportResponseBody = z
    .object({
    serviceReport: ServiceReport,
})
    .meta({ ref: "ReadServiceReportResponseBody" });
